import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UtilidadesService } from '../utilidades.servicios.index';

@Injectable({
    providedIn: 'root'
})
export class PermisoGuard implements CanActivate {

    constructor(private Utilidades: UtilidadesService) {}

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): boolean {
        let TokenValido: boolean = this.Utilidades.TokenValido()

        if (!TokenValido) {
            this.Utilidades.CuadroDeMensaje("Error!", ["- La sesi�n ha caducado."], () => {
                this.Utilidades.RedireccionarAInicioDeSesion(true);
            }, "Aceptar");
        }

        return TokenValido;
    }
}